<div class="image-upload"
     fileDrop
     accept="'image/*'"
     (isFileOver)="fileOver($event)"
     (fileDrop)="fileChange($event)"
     [ngClass]="{'file-is-over': isFileOver}">
  <div class="file-upload hr-inline-group"  *ngIf="!files.length">
    <label class="upload-button">
      <span>{{"Select a file" | translate}}</span>
      <input type="file"
             onclick="this.value=null"
             accept="image/*"
             multiple (change)="fileChange(input.files)"
             #input>
    </label>
    <div class="drag-box-message">{{"Drop file here" | translate}}</div>
  </div>
  <div *ngIf="preview" class="image-container hr-inline-group">
    <div class="image"
         *ngFor="let file of files"
         (click)="onFileClick(file)"
         [ngStyle]="{'background-image': 'url('+ file.src +')'}">
      <div *ngIf="file.pending" class="loading-overlay">
        <div class="spinningCircle"></div>
      </div>
      <div *ngIf="!file.pending" class="x-mark" (click)="deleteFile(file)">
        <span class="close"></span>
      </div>
    </div>
  </div>
  <!--<div *ngIf="uploaded">
    <ul>
      <li *ngFor="let i of uploaded">{{i}}</li>
    </ul>
  </div>-->
</div>
